<div>
<div class="table-fms">
  <table>
    <thead>
      <tr>
        <th *ngFor="let header of headers; let i = index"
          [class.blank-space]="blankSpaceIndices.includes(i)">
          {{header}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let i of [].constructor(trAmount)"
        class="animation-wrapper"
        app-table-empty-state
        [tdAmount]="tdAmount"
        [blankSpaceIndices]="blankSpaceIndices">
      </tr>
    </tbody>
  </table>
</div>
</div>
